import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for managing CMS content, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  MANAGE_CMS: {
    path: `${baseRoutes.adminBaseRoutes}/manage-cms`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-file-docs" />
      </span>
    ),
  },
  TERMS_AND_CONDITION: {
    path: `${baseRoutes.adminBaseRoutes}/terms-and-conditions`,
  },
  PRIVACY_POLICY: {
    path: `${baseRoutes.adminBaseRoutes}/privacy-policy`,
  },
  CONTACT_US: {
    path: `${baseRoutes.adminBaseRoutes}/contact-us`,
  },
  ABOUT_US: {
    path: `${baseRoutes.adminBaseRoutes}/about-us`,
  },
  FAQS: {
    path: `${baseRoutes.adminBaseRoutes}/faqs`,
  },
};

export default accessRoute;
